module.exports = __webpack_public_path__ + "static/mongodb-05b56855fb64dd64f4f516cbcdf76074.svg";